export default __webpack_public_path__ + "static/hq_banner2-b76ac88a04c35887f236e034a59446b5.jpg";